import { gql } from '@apollo/client';

export const LINK_MANAGER_REPORT = gql`
query newTrackingEvents($input: NewTrackingEventsInput) {
    newTrackingEvents(input: $input) {
      count
      totalPages
      limit
      currentPage
      trackingEventReportItems {
        referralUrl
        merchantId
        merchantName
        publisherId
        publisherName
        trackingProfileId
        trackingProfileUrl
        pageType
        adId
        adStatus
        productId
        productName
        impressions
        uniqueImpressions
        clicks
        uniqueClicks
        customizedProductId
        newToSystem
        createdAt
        updatedAt
        CTR
        RPI
        totalTransactions
        totalCommissions
        approvedTransactions
      }
    }
  }
`;
